import ProjectsView from '@/components/views/Projects.vue'
import ProjectView from '@/components/views/Project'
import ProjectDetailsView from '@/components/project/ProjectDetails.vue'
import ProjectEditView from '@/components/views/ProjectEdit.vue'
import ProjectExpensesView from '@/components/expenses/ProjectExpenses.vue'
import ProjectActivitiesView from '@/components/activities/ProjectActivities.vue'
import ProjectFinancialPlanView from '@/components/views/ProjectFinancialPlan'
import ProjectMilestones from '@/components/project/ProjectMilestones'
import ProjectFeed from '@/components/project/ProjectFeed'

export default [
  {
    path: 'projects',
    name: 'projects',
    component: ProjectsView,
    meta: { title: 'All Projects' }
  },
  {
    path: 'projects/new',
    name: 'project-new',
    component: ProjectEditView,
    meta: { title: 'New Project' }
  },
  {
    path: 'projects/:name',
    component: ProjectView,
    children: [
      {
        path: '',
        name: 'project-details',
        component: ProjectDetailsView,
        meta: { parent: 'projects' }
      },
      {
        path: 'edit',
        name: 'project-edit',
        component: ProjectEditView
      },
      {
        path: 'expenses',
        name: 'project-expenses',
        component: ProjectExpensesView
      },
      {
        path: 'plan',
        name: 'project-plan',
        component: ProjectFinancialPlanView
      },
      {
        path: 'activities',
        name: 'project-activities',
        component: ProjectActivitiesView
      },
      {
        path: 'phases',
        name: 'project-phases',
        component: ProjectMilestones
      },
      {
        path: 'health',
        name: 'project-health',
        component: ProjectFeed
      }
    ]
  }
]
